module.exports = __webpack_public_path__ + "img/sqzk.26a7a3bd.png";